import React, { useState, useEffect } from 'react'
// import Card from '@material-ui/core/Card'
// import CardContent from '@material-ui/core/CardContent'
// import { makeStyles } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { useNavigate } from 'react-router-dom'
import moment from 'moment-jalaali'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { ThemeProvider } from '@material-ui/core/styles'
import { getCustomers } from '../../app/slices/customersSlice'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import muiDefaultOptions from '../../constants/muiTableOptions'

// const useStyle = makeStyles(() => ({}))

const AGE_COL_NAME = 'ageCategoryId'
const PROVIENCE_COL_NAME = 'province.name'

const CustomersList = () => {
  // const classes = useStyle()
  const navigate = useNavigate()
  const customers = useSelector((state) => state.customers.list)
  const totalCustomers = useSelector((state) => state.customers.total)
  const proviences = useSelector((state) => state.common.regions)
  const ageCategories = useSelector((state) => state.common.ages)
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const [filteredAgeCategories, setFilteredAgeCategories] = useState([])
  const [filteredProviences, setFilteredProviences] = useState([])
  const [searchTerm, setSearchTerm] = useState(null)
  const updateSearchTerm = debounce((term) => {
    setSearchTerm(term)
  }, 500, { maxWait: 1000 })
  useEffect(() => {
    dispatch(getCustomers({
      ageCategoryIds: filteredAgeCategories.length ? filteredAgeCategories : [],
      proviences: filteredProviences.length ? filteredProviences : [],
      after: currentPage * rowsPerPage,
      first: rowsPerPage,
      query: searchTerm,
    }))
  }, [filteredAgeCategories, filteredProviences, currentPage, rowsPerPage, searchTerm])

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'firstName',
      label: 'نام آزمون دهنده',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => `${value || '-'} ${customers[rowIndex].lastName ? customers[rowIndex].lastName : '-'}`,
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ثبت نام',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
        sort: false,
        filter: false,
      },
    },
    {
      name: 'userName',
      label: 'کد ملی',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'phoneNumber',
      label: 'شماره تماس',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'birthDate',
      label: 'تاریخ تولد',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
        sort: false,
        filter: false,
      },
    },
    {
      name: AGE_COL_NAME,
      label: 'رده سنی',
      options: {
        customBodyRender: (value) => ageCategories.find((cat) => cat.ageCategoryId === value)?.name || '-',
        display: false,
        sort: false,
        filter: true,
        filterOptions: {
          fullWidth: true,
          names: ageCategories.map((cat) => cat.name),
        },
      },
    },
    {
      name: PROVIENCE_COL_NAME,
      label: 'استان',
      options: {
        display: false,
        sort: false,
        filter: true,
        filterOptions: {
          fullWidth: true,
          names: proviences.map((provience) => provience.name),
        },
      },
    },
  ]

  return (
    <ThemeProvider theme={getMuiThemeWithoutPadding}>
      {/* <Card className={classes.root}> */}
      {/* <CardContent> */}
      <MUIDataTable
        data={customers}
        columns={COLUMNS}
        options={{
          searchPlaceholder: 'جستجو بر اساس نام کاربری و کد ملی',
          ...muiDefaultOptions,
          enableNestedDataAccess: '.',
          filterType: 'multiselect',
          serverSide: true,
          count: totalCustomers,
          page: currentPage,
          rowsPerPage,
          onTableChange: (action, state) => {
            const ageColumnIdx = state.columns.findIndex(
              (col) => col.name === AGE_COL_NAME,
            )
            const provienceColumnIdx = state.columns.findIndex(
              (col) => col.name === PROVIENCE_COL_NAME,
            )
            switch (action) {
              case 'changeRowsPerPage':
                setRowsPerPage(state.rowsPerPage)
                break
              case 'filterChange':
                setFilteredAgeCategories(
                  state.filterList[ageColumnIdx].map(
                    (catName) => ageCategories.find(
                      (ageCat) => ageCat.name === catName,
                    )?.ageCategoryId,
                  ),
                )
                setFilteredProviences(
                  state.filterList[provienceColumnIdx].map((name) => ({ name })),
                )
                break
              case 'changePage':
                setCurrentPage(state.page)
                break
              case 'search':
                updateSearchTerm(state.searchText)
                break
              default:
                break
            }
          },
          rowHover: true,
          selectableRows: 'none',
          onRowClick: (rowData) => {
            const user = customers?.find((item) => item.row === rowData[0])
            navigate(`./view/${user?.userId}`)
          },
        }}
      />
      {/* </CardContent>
      </Card> */}
    </ThemeProvider>

  )
}

export default CustomersList
